module.exports = __webpack_public_path__ + "img/goose3.b437b639.jpg";